import './styles.css'
import template from './template.pug';

angular.module('shared-components').component('gccsInputWrapperCheckbox', {
  controller: function () {},
  template: template,
  transclude: true
});
